<div class="flex align-center gap-2 justify-between px-5 mb-5 page-title">
  <h1 class="page-title">{{ title }}</h1>
  <ng-content></ng-content>
</div>
